import React from 'react';
import { useDatabridge } from '@xp-utilities/web';
import { LoadingButton } from '../Messages/Messages';
import { useCustomTealiumTrigger } from '../../hooks/useTealiumTrigger';

export const renderDesktopSignInContainer = (children) => (
  <div className="signin-block" data-testid="signin-block">
    { children }
  </div>
);

export const renderDesktopSignInLoading = () => renderDesktopSignInContainer(<LoadingButton />);

export const useOpenAccountToasterAnalyticsEvent = (isLoggedIn) => {
  const [hasProfileCompletionEnabled] = useDatabridge('flag.hasProfileCompletionEnabled', false);

  const analyticsData = {
    eventName: 'universal_click',
    eventData: {
      event_name: 'click',
      data_text: 'account toaster',
      data_action: 'click',
      user_state: isLoggedIn ? 'authenticated' : 'guest',
      complete_profile_badge: hasProfileCompletionEnabled ? 'true' : 'not set',
    },
  };

  return useCustomTealiumTrigger(analyticsData);
};
